module.exports = __webpack_public_path__ + "assets/img/graph-gray.webp?60cb5bcdc0e513a453eadea4d0fe8afa";